module.exports = __webpack_public_path__ + "img/logo-slack.9a05c08a.svg";